
import heroimg from "../../../../../images/LandingPageImage/mn_home_screen.webp";
import google from "../../../../../images/LandingPageImage/google.png";
import '../../styles/LandingPageCss/MainHomeSection.css'
import { Link } from "react-router-dom";

import { useModal } from '../../../../../MyContext'



export default function MainHomeSection() {
    const { openModal } = useModal();
    return (
        <>
            <section className="hero-section py-5 py-md-5 font-inter">
                <div className="container px-3 px-lg-4">

                    <div className="row align-items-center gx-lg-5 gy-5">


                        <div className="col-12 col-md-6 order-2 order-md-1">
                            <div className="hero-content text-center text-md-start">
                                <h1 className="hero-title text-purple font-spacegrotesk fw-semibold">
                                    Smarter Messaging for
                                    Faster Business Growth
                                </h1>

                                <p className="hero-subtitle mt-3">
                                    In the digital first world, customers require brands to communicate with them instantly and meaningfully. Late responses, unresponded messages or disconnecting conversations would easily result in missed opportunities.
                                </p>

                                <p className="hero-subtitle d-none d-sm-block">
                                    Businesses can use our platform to control conversations, deliver critical notifications, and automate interactions in one simple system.
                                </p>

                                <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                                 
                                    <Link to="/login" className="btn d-flex align-items-center text-decoration-none bg-neon-purple rounded-1 text-white justify-content-center gap-2 home-btn-primary fw-medium hover-scale">

                                        <span
                                            className="rounded-circle bg-white d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{ width: "30px", height: "30px" }}
                                        >
                                            <img
                                                src={google}
                                                alt="Google"
                                                style={{ width: "20px", height: "20px" }}
                                                className="img-fluid"
                                            />
                                        </span>


                                        <span className="text-nowrap fs-6">
                                            Start With Google
                                        </span>
                                    </Link>
                                    
                                    <button
                                        onClick={openModal}
                                        className="btn d-flex align-items-center justify-content-center bg-white rounded-1   home-btn-secondary fw-medium">
                                        <span className="text-nowrap fs-5">Book a Demo</span>
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div className="col-12 col-md-6 order-2 order-md-2">
                            <div className="hero-image-wrapper d-flex justify-content-center align-items-center">
                                <div className="hero-circle-bg">

                                    <div className="circle-element "></div>
                                    <img
                                        src={heroimg}
                                        alt="WhatsApp marketing dashboard"
                                        className="hero-img img-fluid  rounded-4"
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

        </>
    );
}